<template>
  <div style="background: #f9f9f9; height: calc(100vh - 44px)">
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter">
        <img src="@/assets/img/appointment/back.svg" />
      </div>
      <div class="nav-title d-allcenter overflow">预约结果</div>
      <div class="nav-right d-allcenter" style="font-size: 12px"></div>
    </div>
    <div class="content d-aligncnter d-column d-allcenter">
      <div
        style="width: 72px; height: 72px; border-radius: 50%; background: #f97423; margin-top: 32px"
        class="d-allcenter"
      >
        <img src="@/assets/img/appointment/error.svg" />
      </div>
      <div style="margin-top: 16px" class="weight fs-lg">付款失败！</div>
      <div style="margin-top: 16px; padding: 0 32px; font-size: 14px" class="grey">
        还剩<span style="color: #e14c46; margin: 0 8px" v-text="getCancelTime"></span>订单自动取消
      </div>
      <!-- <div class="order-info">
        <div class="d-aligncnter">
          <div class="grey">场地</div>
          <div style="margin-left: 16px">北校区龙狮足球场1号场地</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px">
          <div class="grey">日期</div>
          <div style="margin-left: 16px">2023-09-09 10:00-11:00</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px">
          <div class="grey">姓名</div>
          <div style="margin-left: 16px">张三</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px">
          <div class="grey">手机</div>
          <div style="margin-left: 16px">15288888888</div>
        </div>
        <div class="d-aligncnter" style="margin-top: 4px">
          <div class="grey">费用</div>
          <div style="margin-left: 16px">￥25</div>
        </div>
      </div> -->
    </div>
    <div class="d-allcenter">
      <button class="save-btn" style="width: 120px">去支付</button>
    </div>
  </div>
</template>
<script>
// import { Message } from 'element-ui'
export default {
  data() {
    return {
      phone: '',
      userInfo: { headImg: '', name: '', mobile: '' },
      rightText: '编辑',
      radio: 0,
      cancelTime: 1800,
    }
  },
  computed: {
    getCancelTime() {
      var minutes = Math.floor((this.cancelTime % 3600) / 60)
      var remainingSeconds = this.cancelTime % 60
      return minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0')
    },
  },
  mounted() {
    setInterval(() => {
      if (this.cancelTime > 0) {
        this.cancelTime--
      }
    }, 1000)
  },

  methods: {},
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';

.mt-16 {
  margin-top: 16px;
}
.content {
  padding: 0;
  background: #f9f9f9;
}
.each {
  background: #f9f9f9;
  box-shadow: 0px -1px 0px 0px #e8e8e8 inset;
  padding: 8px 16px;
  min-height: 32px;
  color: #181818;
}
.photo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d4a3fc;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.save-btn {
  border-radius: 52px;
  //   background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%);
  background: #339571;
  width: 343px;
  height: 42px;
  border: 1px solid #339571;
  color: #fff;
  font-size: 14px;
  margin-top: 16px;
  //   position: absolute;
  //   bottom: 152px;
}
.ml-16 {
  margin-left: 16px;
}
.order-info {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px #e8e8e8;
  padding: 16px;
  margin: 16px;
  width: calc(100% - 94px);
}
</style>
